<template>
    <div class="text-white text-center">
        SteamTrading.Cards is not affiliated with Valve Corporation in any way. All trademarks are property of their respective owners in the US and other countries.
    </div>

</template>